<template>
    <div class="simple-airport-product-card" data-test="ui-simple-airport-product-card">
        <div class="card-image-wrap">
            <div class="card-image-container">
                <NuxtLink class="card-image-link" :to="getInternalLink(blok.link)">
                    <NuxtImg
                        v-if="blok?.image?.filename"
                        :src="blok.image.filename"
                        :title="blok.image.title"
                        :alt="blok.image.alt"
                        provider="storyblok"
                        format="webp"
                        loading="lazy"
                        densities="x1"
                    />
                </NuxtLink>
            </div>
        </div>
        <div class="card-content-wrap">
            <div class="text-wrap">
                <h3 class="title">
                    <NuxtLink :to="getInternalLink(blok.link)">{{ blok.title }}</NuxtLink>
                </h3>
                <p class="description">{{ blok.description }}</p>
            </div>
            <NuxtLink :to="getInternalLink(blok.link)" class="link-btn">{{ blok.link_text }}</NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ISimpleAirportProduct } from '@nuxt-monorepo/ui/types/components/ProductsCards/SimpleAirportProduct';
import { getInternalLink } from '@nuxt-monorepo/ui/utils/internalLinking';

defineProps<{
    blok: ISimpleAirportProduct;
}>();
</script>

<style lang="postcss" scoped>
.simple-airport-product-card {
    @apply flex flex-col md:flex-row rounded p-[15px] md:pr-5 md:pb-[9px] lg:pb-[15px] overflow-hidden;
    @apply border border-solid border-[#e2e2e2] bg-gray;
    .card-image-wrap {
        @apply w-full h-[192px] md:w-[309px] md:h-[124px];
        img {
            @apply flex self-center md:inline-block md:max-h-full md:max-w-full;
        }
    }
    .card-image-container {
        @apply w-full h-full flex items-center justify-center;
    }
    .card-image-link {
        @apply flex overflow-hidden h-full md:h-auto;
    }
    .card-content-wrap {
        @apply w-full overflow-hidden py-[5px] px-[18px] lg:pb-4 lg:pl-[22px] flex items-start lg:gap-5 flex-col lg:flex-row;
    }
    .text-wrap {
        @apply grow;
    }

    .title {
        @apply text-primary hover:text-[#0056b3] text-xl leading-6 font-semibold mb-1;
    }
    .description {
        @apply text-[15px] text-[#454545] leading-5 font-semibold;
    }
    .link-btn {
        @apply text-base lg:text-xl leading-5 lg:leading-6 font-bold text-center text-white uppercase;
        @apply mt-2.5 pt-3 px-[25px] pb-[10px] lg:py-[14px] lg:pr-[30px] lg:pl-[38px] bg-primary hover:bg-secondary rounded-md shrink-0;
        transition: all 0.4s ease;
    }
}
</style>
